import { SearchableTypes } from './types';

export const getSearchResultsListId = (
  query: string,
  type: SearchableTypes,
) => {
  return `search-${type}-results:${query}`;
};
